module.exports = __webpack_public_path__ + "images/gc_image_1_b331acafc26d7afbe2e6a10ffc80151a.jpg";